export default {
  ctaText: "Show my financial overview",
  sidePanelSubtitle:
    "Check the inventory overview.",
  sidePanelTitle: "End of day!",
  tagLabel: "End of the day"
};
